export function collapsedTabsText() {
    if (window.innerWidth >= 992) return;

    const initItem = (item) => {
        const content = item.querySelector('.tabs-component__content');
        if (!content) return;
        if (content.dataset.collapsedInit) return;

        content.dataset.collapsedInit = "true";
        content.classList.add('is-collapsible');

        requestAnimationFrame(() => {
            const height = content.scrollHeight;

            if (height <= 160) {
                content.classList.remove('is-collapsible');
                return;
            }

            content.style.height = '160px';
            content.style.overflow = 'hidden';

            const button = document.createElement('button');
            button.className = 'tabs-component__collapse-button';
            button.innerHTML = '<span></span>';

            let expanded = false;

            button.addEventListener('click', () => {
                expanded = !expanded;
                content.style.height = expanded
                    ? `${content.scrollHeight}px`
                    : '160px';
                button.classList.toggle('is-expanded', expanded);
            });

            item.appendChild(button);
        });
    };

    const run = () => {
        document
            .querySelectorAll('.accordion__item--active')
            .forEach(initItem);
    };

    run();

    document.addEventListener('click', () => {
        setTimeout(run, 0);
    });
}